import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { BranchList } from '~/features/BranchList';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import styles from './styles.module.scss';

/**
 * 事業所一覧 Screen
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='事業所' />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <BranchList />
        </Suspense>
      </main>
    </div>
  </div>
);
